import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { UserService, Role } from '../services/user.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-add-new-user',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, MatIconModule],
  templateUrl: './add-new-user.component.html',
  styleUrl: './add-new-user.component.css'
})
export class AddNewUserComponent implements OnInit {
  newUser = {
    id: null,
    username: '',
    password: '',
    company: localStorage.getItem('company') || '',
    companyId: localStorage.getItem('companyId') || '',
    firstname: null,
    lastname: null,
    email: null,
    phoneNumber: null,
    job_title: null,
    selectedRoles: [] as number[]
  };

  confirmPassword = '';
  availableRoles: Role[] = [];
  
  loading = false;
  error: string | null = null;
  success = false;

  constructor(
    private userService: UserService,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.loadRoles();
  }

  /*
  loadRoles(): void {
    this.userService.getAllRoles().subscribe({
      next: (roles) => {
        this.availableRoles = roles;
      },
      error: (err) => {
        console.error('Failed to load roles', err);
        this.error = 'Failed to load user roles';
      }
    });
    }
    */
   //  PJy 26 March 2026  Only load Ourscource roles for OutSoureAdmin
   loadRoles(): void {
   if (this.authService.hasRole('Admin'))
   {
    this.userService.getAllRoles().subscribe({
      next: (roles) => {
        this.availableRoles = roles;
      },
      error: (err) => {
        console.error('Failed to load roles For Admin', err);
        this.error = 'Failed to load user roles for Admin';
      }
    });
   }
   else
   {
    this.userService.getAllRoles().subscribe({
      next: (roles) => {
        this.availableRoles = roles.filter(role =>
          role?.name?.toLowerCase().startsWith('outsource')
      );
      },
    error: (err) => {
      console.error('Failed to load roles for Outsource', err);
      this.error = 'Failed to load user roles for OurSource';
      }
    });
  }
}



  isRoleSelected(roleId: number): boolean {
    return this.newUser.selectedRoles.includes(roleId);
  }

  toggleRole(roleId: number): void {
    const index = this.newUser.selectedRoles.indexOf(roleId);
    if (index === -1) {
      this.newUser.selectedRoles.push(roleId);
    } else {
      this.newUser.selectedRoles.splice(index, 1);
    }
  }

  createUser(): void {
    this.loading = true;
    this.error = null;
    
    // Validate passwords match
    if (this.newUser.password !== this.confirmPassword) {
      this.error = 'Passwords do not match';
      this.loading = false;
      return;
    }

    // Prepare user data with selected roles
    const userData = {
      ...this.newUser,
      id: this.newUser.id || null, // Ensure id is optional
      roles: this.newUser.selectedRoles.map(id => id.toString())
    };
    
    // Remove the selectedRoles property before sending
    const { selectedRoles, ...userToCreate } = userData;

    this.userService.createUser(userToCreate).subscribe({
      next: (response) => {

        const userId = response.id;

            selectedRoles.forEach(roleId => {
            this.userService.assignRoleToUser({ userId, roleId: roleId.toString() }).subscribe({
              next: () => console.log('Role assigned:', roleId),
            });
          });


        this.success = true;
        this.loading = false;
        
        // Redirect to roles management after a short delay
        setTimeout(() => {
          this.router.navigate(['/roles/edit']);
        }, 2000);
      },
      error: (err) => {
        this.error = err.error || 'Failed to create user';
        this.loading = false;
        console.error(err);
      }
    });
  }
}